<!-- filter -->
<div ng-if="$ctrl.filterConfig && ($ctrl.list.totalCount + $ctrl.list.count > 0)" class="list-filter">
    <div class="list-filter-fixed">
        <div class="list-filter-main">
            <div class="list-filter-tools" ng-if="$ctrl.showFilter" style="height: auto;overflow: visible;">
                <div centuri-list-filter class="list-filter-elements" showing="$ctrl.showFilter" config="$ctrl.filterConfig" callback="$ctrl.filterCallback">
                </div>
            </div>
            <div class="list-filter-status">
                <div class="list-filter-status-text">{{$ctrl.statusText}}</div>
            </div>
        </div>
        <div class="list-filter-switch" ng-click="$ctrl.filterToggle()">{{'filterShow'|translate}}</div>
    </div>
</div>
<div ng-if="$ctrl.list.count > 0 && $ctrl.searchSuggestion && $ctrl.searchSuggestion.didYouMean" class="search-suggestions">
    <div class="search-suggestions-fixed">
        <h3> <label>{{"didYouMean"|translate}}:</label>
            <a class="spell-sugg" ui-sref="read.search({ searchQuery: $ctrl.searchSuggestion.didYouMean })"><span ng-bind-html="$ctrl.searchSuggestion.markup"></span></a>
        </h3>
    </div>
</div>
<!-- header -->
<div ng-if="$ctrl.headerTemplate">
    <c-list-item-container item-template="$ctrl.headerTemplate" list-item="$ctrl.header"></c-list-item-container>
</div>
<!-- list -->
<div ng-if="$ctrl.inContainer" class="list-container">
    <div class="list-scroller"></div>
</div>
<div class="list-content validation" ng-class="{'not-selected': $ctrl.selectedIds.length === 0, 'fixed-content': !$ctrl.inContainer}">
    <ul class="list-ctx">
        <li ng-repeat="item in $ctrl.displayItems track by item.index">
            <div ng-if="item && item.loaded===undefined" class="list-item empty" ng-style="{ height: $ctrl.itemHeight }"></div>
            <div ng-if="item && item.loaded===false" class="list-item loading" ng-style="{ height: $ctrl.itemHeight }">
                <div class="spinner-padding">
                    <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                </div>
            </div>
            <div ng-if="item && item.endOfList && (!$ctrl.noEndOfList)" class="list-item end-of-list">
                <div ng-if="$ctrl.displayItems && $ctrl.list.count === 0">
                    <h3>
                        {{$ctrl.noItemsInList}}
                        <div ng-if="$ctrl.searchSuggestion && $ctrl.searchSuggestion.didYouMean" class="search-suggestion">
                            <label>{{"didYouMean"|translate}}:</label>
                            <a ui-sref="read.search({ query: $ctrl.searchSuggestion.didYouMean })"><span ng-bind-html="$ctrl.searchSuggestion.markup"></span></a>
                        </div>
                    </h3>
                </div>                
                <div ng-if="!$ctrl.noEndOfList" class="end-image" ng-bind-html="$ctrl.endImage">
                </div>
            </div>
            <div ng-if="item && item.loaded===true && !item.endOfList" class="content-wrapper list-item loaded" ng-class="$ctrl.activeClassNames(item.id, item.index)" ng-click="$ctrl.itemClick($event, item.id, item)">
                <div ng-if="item.indicatorColor" class="indicator" ng-class="item.indicatorColor"></div>
                <div ng-if="$ctrl.listOptions.showCheckboxes" class="checkbox" ng-click="$ctrl.clickPassthru($event, item.id, item)">
                    <c-checkbox checked="$ctrl.checkedBox(item.id)"></c-checkbox>
                </div>
                <div class="container">
                    <c-list-item-container item-template="$ctrl.itemTemplate" list-item="item" highlight="$ctrl.highlightWords"></c-list-item-container>
                </div>
            </div>
        </li>
    </ul>
</div>
<div ng-if="!($ctrl.inContainer) && !($ctrl.renderOnly)" class="list-scroller"></div>
<!-- messages -->
<div ng-if="$ctrl.showEmptyMessage" class="no-list-items">
    <h3>{{$ctrl.noItemsInList}}
        <span ng-if="$ctrl.searchSuggestion && $ctrl.searchSuggestion.didYouMean">
            <label>{{"didYouMean"|translate}}:</label> <a class="search-suggestion" ui-sref="read.search({ searchQuery: $ctrl.searchSuggestion.didYouMean })"><span ng-bind-html="$ctrl.searchSuggestion.markup"></span></a>
        </span>
    </h3>
</div>